<template>
  <div class="common-box">
    <div>
      <el-form
        inline
        ref="form"
        class="search-form common-box-search-form"
        label-position="right"
        :model="form"
        label-width="70px"
      >
        <search-form @search="handleSearch" @refresh="handleRefresh">
          <div slot="content">
            <el-form-item label="来源：">
              <el-select
                size="mini"
                v-model="form.sourceType"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in wxflyDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="来源单号：">
              <el-input
                size="mini"
                v-model.trim="form.orderNo"
                placeholder="请输入来源单号"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属项目：">
              <el-select
                size="mini"
                v-model="form.projectId"
                filterable
                placeholder="请选择所属项目"
                clearable
                reserve-keyword
                :remote="true"
                @change="handleSearchListData"
                :remote-method="searchProjectList"
                @visible-change="searchProjectList('')"
                value-key="id"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.projectName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提交人：">
              <el-input
                size="mini"
                v-model.trim="form.submitterName"
                placeholder="请输入提交人"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="收款人：">
              <el-input
                size="mini"
                v-model.trim="form.receiverName"
                placeholder="请输入收款人"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="配件名称：">
              <el-input
                size="mini"
                v-model.trim="form.partName"
                placeholder="请输入配件名称"
                clearable
                @change="handleSearchListData"
              ></el-input>
            </el-form-item>
            <el-form-item label="费用类型：">
              <el-select
                size="mini"
                v-model="form.feeType"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in wxffylxDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收费状态：">
              <el-select
                size="mini"
                v-model="form.paymentStatus"
                @change="handleSearchListData"
              >
                <el-option
                  v-for="item in wxfsfztDicts"
                  :key="item.dictionaryCode"
                  :label="item.dictionaryValue"
                  :value="item.dictionaryCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收费日期：">
              <el-date-picker
                v-model="receiptTime"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                @change="handleSearchListData"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="所属部门：">
              <el-cascader
                placeholder="请选择所属部门"
                :options="departmentTree"
                :props="propsTree"
                filterable
                @change="handleDepartment"
                ref="cascader"
                collapse-tags
                size="mini"
                v-model="departmentIdList"
              ></el-cascader>
            </el-form-item>
          </div>
        </search-form>
      </el-form>
    </div>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          v-if="hasRole['WXFTJ']"
          @click="handleAdd"
          >添加</el-button
        >
         <el-button
          size="mini"
          type="primary"
          @click="exportRepair"
          plain
          class="plr28"
          v-if="hasRole['WXFDC']"
          >导出</el-button
        >
        <el-button
          size="mini"
          type="primary"
          @click="handleDelete"
          plain
          class="plr28"
          v-if="hasRole['WXFSC']"
          >删除</el-button
        >
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
          class="table-sortable-reset-header-padding"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="sourceTypeName"
            label="来源"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="orderNo"
            label="来源单号"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="projectName"
            label="所属项目"
            width="150"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="resourceName"
            label="所属合同"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="resourceName"
            label="负责部门"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="liftName"
            label="电梯"
            width="100"
          ></el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="amount"
            label="金额"
            width="100"
          >
            <template slot-scope="scope">{{
              scope.row.amount | separator
            }}</template>
          </el-table-column>
          
          <el-table-column
            show-overflow-tooltip
            prop="partNameGroup"
            label="配件名称"
            width="200"
          >
            <!-- <template slot-scope="scope">
              <span>{{ scope.row.resourceType.name }}</span>
            </template> -->
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="paymentStatusName"
            label="应收状态"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            align="right"
            header-align="right"
            prop="receivableAmount"
            label="应收金额"
            width="100"
          >
            <template slot-scope="scope">{{
              scope.row.receivableAmount | separator
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="receiverName"
            label="应收人"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="receivableTime"
            label="应收日期"
            width="100"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="attachmentName"
            label="附件"
            width="100"
          ></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['WXFFY']"
                type="text"
                @click="handleEdit(scope.row)"
                >费用</el-button
              >
              <div class="btn-divide" v-if="hasRole['WXFFY']"></div>
              <el-button
                size="mini"
                v-if="hasRole['WXFSC']"
                type="text"
                @click="handleDeleteOne(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-dialog
      v-if="showAdd"
      :appCode="form.appCode"
      @cancel="showAdd = false"
      @confirm="confirm"
    ></add-dialog>
    <edit-dialog
      :appCode="form.appCode"
      v-if="showEdit"
      :editData="detailData"
      @cancel="showEdit = false"
      @confirm="confirm"
    ></edit-dialog>
  </div>
</template>

<script>
import { getPageList, batchDelete, exportRepair } from "@/api/MaintenanceFeeConfirmation";
import addDialog from "./components/addDialog.vue";
import editDialog from "./components/editDialog.vue";
import { getProjectSimpleList } from "@/api/MaintenanceWorkOrder";
import {
  getDepartmentTree,
} from "@/api/ElevatorManagement";
import { mapState } from "vuex";
export default {
  name: "MaintenanceFeeConfirmation",
  components: {
    addDialog,
    editDialog,
  },
  data() {
    return {
      showAdd: false,
      showEdit: false,
      detailData: {},
      form: {
        feeType: '',
        orderNo: '',
        sourceType: '',
        projectId: '',
        submitterName: '',
        receiverName: '',
        partName: '',
        paymentStatus: ''


      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      projectList: [],
      receiptTime: null,
      departmentTree: [],
      propsTree: {
        multiple: true,
        value: "id",
        label: "departmentName",
        children: "childrenList",
        // checkStrictly: true
      },
      departmentIdList: [],
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", [
      "wxflyDicts",
      "wxffylxDicts",
      "wxfsfztDicts",
    ]),
  },
  created() {
    this.getListData();
    this.getDepartmentTree();
  },
  methods: {
    async getDepartmentTree() {
      const res = await getDepartmentTree({ pageIndex: 1, pageSize: 1000 });
      if (res.code === 200) {
        this.departmentTree = res.data;
      }
    },
    async searchProjectList(keyword) {
      const res = await getProjectSimpleList({
        keyword: keyword,
        size: 1000,
      });
      if (res.code === 200) {
        this.projectList = res.data;
      }
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      this.pageIndex = 1;
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.receiptTime = null
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(row) {
      this.detailData = row;
      this.detailData.paymentStatus = this.detailData.paymentStatus.toString()
      this.showEdit = true;
    },
    async handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的资源");
        return;
      }
      let idList = this.multipleSelection.map((item) => item.id);
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await batchDelete({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async handleDeleteOne(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await batchDelete({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.showAdd = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    getParams() {
      if (this.receiptTime && this.receiptTime.length) {
        this.form.receiptTimeStart = this.receiptTime[0];
        this.form.receiptTimeEnd = this.receiptTime[1];
      } else {
        this.form.receiptTimeStart = ""
        this.form.receiptTimeEnd = ""
      }
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      return params;
    },
    async getListData() {
      this.tableLoading = true;
      const params = await this.getParams();
      const res = await getPageList(params);
      if (res.code === 200) {
        this.list = [...res.data.list];
        this.total = res.data.total;
      }
      this.tableLoading = false;
    },
    confirm() {
      this.showAdd = false;
      this.showEdit = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleDepartment(val) {
      this.form.departmentIdList = [];
      if (val && val.length) {
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.idList.push(item.data.id);
        });
      }
      this.handleSearchListData();
    },
    	// 列表排序
		handleSortChange({column, prop, order}) {
		  if (order === 'ascending') {
		    this.form.sortOrder = 'asc';
				this.form.sortField = prop
		  } else if (order === 'descending') {
		    this.form.sortOrder = 'desc';
				this.form.sortField = prop
		  } else {
		    this.form.sortField = '';
		    this.form.sortOrder = '';
		  }
		  this.getListData();
    },
    exportRepair() {
      const params = this.getParams()
      exportRepair(params)
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/MaintenanceFeeConfirmation/MaintenanceFeeConfirmation.vue